type StreamData = {
  reference: string;
  url: string;
  serverType: string;
  mediaType: string;
}

export default class Stream {
  reference: string;
  url: string;
  serverType: string;
  mediaType: string;

  constructor(data: StreamData) {
    this.reference = data.reference;
    this.url = data.url;
    this.serverType = data.serverType;
    this.mediaType = data.mediaType;
  }

  static parse(data: Object) {
    return new Stream(data);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/streaming/domain/Stream.js